import { PageTemplate } from '../types/pageBuilder';

const USER_TEMPLATES_KEY = 'pageBuilder_userTemplates';

export interface UserTemplate extends PageTemplate {
  createdAt: string;
  updatedAt: string;
  isUserTemplate: true;
}

export const getUserTemplates = (): UserTemplate[] => {
  try {
    const stored = localStorage.getItem(USER_TEMPLATES_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error reading user templates:', error);
  }
  return [];
};

export const saveUserTemplate = (template: {
  name: string;
  description: string;
  category: string;
  gjsHtml: string;
  gjsCss: string;
  gjsComponents: string;
  gjsStyles: string;
  thumbnail?: string;
}): UserTemplate => {
  const templates = getUserTemplates();

  const newTemplate: UserTemplate = {
    id: `user-${Date.now()}`,
    name: template.name,
    description: template.description,
    category: template.category,
    thumbnail: template.thumbnail || `https://placehold.co/400x300/6366f1/white?text=${encodeURIComponent(template.name.slice(0, 15))}`,
    gjsHtml: template.gjsHtml,
    gjsCss: template.gjsCss,
    gjsComponents: template.gjsComponents,
    gjsStyles: template.gjsStyles,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isUserTemplate: true
  };

  templates.unshift(newTemplate);
  localStorage.setItem(USER_TEMPLATES_KEY, JSON.stringify(templates));

  return newTemplate;
};

export const deleteUserTemplate = (templateId: string): boolean => {
  try {
    const templates = getUserTemplates();
    const filtered = templates.filter(t => t.id !== templateId);
    localStorage.setItem(USER_TEMPLATES_KEY, JSON.stringify(filtered));
    return true;
  } catch (error) {
    console.error('Error deleting user template:', error);
    return false;
  }
};

export const updateUserTemplate = (
  templateId: string,
  updates: Partial<Pick<UserTemplate, 'name' | 'description' | 'category' | 'gjsHtml' | 'gjsCss' | 'gjsComponents' | 'gjsStyles'>>
): UserTemplate | null => {
  try {
    const templates = getUserTemplates();
    const index = templates.findIndex(t => t.id === templateId);

    if (index === -1) return null;

    templates[index] = {
      ...templates[index],
      ...updates,
      updatedAt: new Date().toISOString()
    };

    localStorage.setItem(USER_TEMPLATES_KEY, JSON.stringify(templates));
    return templates[index];
  } catch (error) {
    console.error('Error updating user template:', error);
    return null;
  }
};
